import { instance as axios } from "../utils/AxiosInstance";

class ProfileService {
    get() {
        return axios.get(`/profiles`);
    }

    update(data: any) {
        return axios.put(`/profiles`, data);
    }

    enrolled() {
        return axios.put(`/profiles/enrolled`);
    }

    notEnrolled() {
        return axios.put(`/profiles/not_enrolled`);
    }

    initializeProfile(data: any) {
        return axios.put(`/profiles/initialize_profile`, data);
    }
}

export default new ProfileService();
